import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { FortnoxImportRun } from '../../models/FortnoxImportRun';

/** Stops an import that is running. It can be resumed later from where it stopped. */
export const useStopFortnoxImport = () => {
  const { callAPI } = useAPI<FortnoxImportRun>({ method: 'POST' });

  const action = async (runId: string): Promise<FortnoxImportRun> =>
    (await callAPI(buildApiUrl(`fortnoxImport/${runId}/stop`))) as FortnoxImportRun;

  return { action };
};
